<template>
  <div>
    <InputSwitch
      :inputId="inputId"
      v-model="inputValue"
      :disabled="disabled"
      :aria-label="areaLabel"
      @change="$emit('change', $event)"
      @click="$emit('click', $event)"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    />
  </div>
</template>

<script>
import InputSwitch from "primevue/inputswitch";
export default {
  components: {
    InputSwitch,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    inputId: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    areaLabel: {
      type: String,
      default: "",
    },

    disabled: {
      type: String,
    },
  },

  computed: {
    inputValue: {
      get: function () {
        return this.value;
      },
      // setter
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
